<div class="c-company-selector__user">
    <div class="c-company-selector__wrapper"
        [class.c-company-selector__wrapper--is-busy]="isBusy">
        <div class="c-company-selector__name">
            {{ user?.name }}
        </div>
        <div class="c-company-selector__company">
            {{ company?.name }}
        </div>
    </div>
    
    <ihd-loader class="c-loader--xs" *ngIf="isBusy"></ihd-loader>
</div>
<div class="c-company-selector__divider"></div>
<ng-container *ngIf="companies?.length">
    <div class="c-company-selector__companies-list">
        <div class="c-list c-list--xs x-company-list-wrapper">
    
            <div class="c-list__item is-clickable x-company-selector-item" *ngFor="let availableCompany of companies; let last = last;"
                [class.mb-0]="last"
                [class.mb-2]="!last"
                (click)="changeCompany(availableCompany)">
                <ihd-avatar class="mr-2 c-avatar--sm"
                    [isSingleInitial]="true"
                    [class.c-avatar--admin]="availableCompany.role === ACCOUNT_ROLE.ADMIN"
                    [class.c-avatar--manager]="availableCompany.role === ACCOUNT_ROLE.MANAGER"
                    [user]="availableCompany"></ihd-avatar>
                {{ availableCompany.name }}
            </div>
        </div>
    </div>
    <div class="c-company-selector__divider"></div>
</ng-container>
